import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Youtube, Linkedin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-black mt-24">
      <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 border border-gold-30 flex items-center justify-center">
              <span className="font-display text-gold text-lg">ZB</span>
            </div>
            <div>
              <div className="font-display text-xl">ZB Campus</div>
              <div className="text-[10px] uppercase tracking-[0.32em] text-gold">Muhasebe Akademisi</div>
            </div>
          </div>
          <p className="text-white/60 max-w-md text-sm leading-relaxed">
            Zülfikar Benli önderliğinde, sahada işe yarayan gerçek muhasebe bilgisiyle kariyerinizi bir sonraki seviyeye taşıyan premium eğitim platformu.
          </p>
          <div className="hairline my-6 max-w-md" />
          <div className="flex items-center gap-4">
            <a href="https://instagram.com/zbcampus" target="_blank" rel="noreferrer" className="text-white/60 hover:text-gold" data-testid="footer-instagram">
              <Instagram className="w-5 h-5" />
            </a>
            <a href="https://youtube.com/@zbcampus" target="_blank" rel="noreferrer" className="text-white/60 hover:text-gold" data-testid="footer-youtube">
              <Youtube className="w-5 h-5" />
            </a>
            <a href="https://linkedin.com/in/zulfikarbenli" target="_blank" rel="noreferrer" className="text-white/60 hover:text-gold" data-testid="footer-linkedin">
              <Linkedin className="w-5 h-5" />
            </a>
            <a href="mailto:info@zbcampus.com" className="text-white/60 hover:text-gold" data-testid="footer-email">
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <div className="section-eyebrow mb-4">Keşfet</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/egitimler" className="hover:text-gold">Eğitim Kataloğu</Link></li>
            <li><Link to="/egitmen" className="hover:text-gold">Eğitmen</Link></li>
            <li><Link to="/blog" className="hover:text-gold">Blog</Link></li>
            <li><Link to="/iletisim" className="hover:text-gold">İletişim</Link></li>
            <li><Link to="/kayit-formu" className="hover:text-gold">Kayıt Formu</Link></li>
          </ul>
        </div>

        <div>
          <div className="section-eyebrow mb-4">Kategoriler</div>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/egitimler?kategori=%C3%96n%20Muhasebe" className="hover:text-gold">Ön Muhasebe</Link></li>
            <li><Link to="/egitimler?kategori=Genel%20Muhasebe" className="hover:text-gold">Genel Muhasebe</Link></li>
            <li><Link to="/egitimler?kategori=Beyanname" className="hover:text-gold">Beyanname</Link></li>
            <li><Link to="/egitimler?kategori=%C4%B0leri%20Seviye" className="hover:text-gold">İleri Seviye</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-white/50">
          <div>© {new Date().getFullYear()} ZB Campus — zbcampus.com. Tüm hakları saklıdır.</div>
          <div className="flex items-center gap-6">
            <span>Kullanım Şartları</span>
            <span>Gizlilik</span>
            <span>KVKK</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
